export const COMPONENT_PROGRESS_LEVELS = [
    { maxPercent: 25, color: 'red', label: ['0%-25%', 'Insufficient'] },
    { maxPercent: 50, color: 'orange', label: ['26%-50%', 'Incomplete'] },
    { maxPercent: 75, color: 'yellow', label: ['51%-75%', 'Sufficient'] },
    { maxPercent: 90, color: 'blue', label: ['76%-89%', 'Substantial'] },
    { maxPercent: 101, color: 'green', label: ['90%-100%', 'Complete'] },
];
